<template>
  <SectionPrice class="mb-5" :data="webchatDataPrice">
    <template #title>
      <h2 v-if="title">
        {{ title }}
      </h2>
    </template>
    <div class="flex flex-col justify-between h-full">
      <div class="text-center text-xs">{{ webchatDataPrice.slot.sal }}</div>
      <span
        class="flex items-center justify-center mt-4"
        :class="{ 'line-through': webchatDataPrice.offPrice }"
      >
        <!-- <span>از</span> -->
        <span
          :class="webchatDataPrice.offPrice ? '' : 'mx-1 text-xl font-bold'"
          >{{ webchatDataPrice.slot.price }}</span
        >
        <span>هزار تومان</span>
      </span>
      <span
        v-if="webchatDataPrice.offPrice"
        class="flex items-center justify-center font-bold"
      >
        <span class="mx-1 text-xl">{{ webchatDataPrice.offPrice }}</span>
        <span>تومان</span>
      </span>
      <div class="flex items-center mt-6">
        <BaseButton
          isLean
          size="full"
          class="text-xs"
          :text="webchatDataPrice.slot.btnOrder"
          @click="showMainModal"
          :id="setIdByPath('cta')"
        />
      </div>
    </div>
  </SectionPrice>
</template>

<script setup>
defineProps({
  title: String,
});

const webchatDataPrice = {
  id: 1,
  label: "مناسب تمام سایت‌ها",
  subTitle: "چت آنلاین نواتل",
  desc: "با استفاده از سرویس چت آنلاین نواتل، ارتباطی موثر با بازدیدکنندگان سایت خود برقرار کنید و  نرخ فروش محصولات و خدمات تان را به میزان قابل توجهی افزایش دهید.",
  options: [
    {
      id: "1",
      text: "دریافت و پاسخگویی به پیام‌ها در اپلیکیشن",
    },
    {
      id: "2",
      text: "شخصی‌سازی باکس گفتگو متناسب با تم سایت",
    },
  ],
  slot: {
    sal: "به ازای هر کاربر در ماه",
    price: "540",
    btnOrder: "ثبت سفارش",
  },
  // off: "20",
  // offPrice: "3/600/000", 
};

const modalsStore = useModalsStore();

const showMainModal = () => {
  modalsStore.openModal('CTA');
};
</script>
